import React from 'react';
import { Header } from '../Layouts/Header';
import '../../styles/homepage.css';
import '../../styles/otherpage.css';
import about from '../../assets/imgs/about.svg';
import Footer from '../Layouts/Footer';
import CallToActionButton from '../Layouts/CallToActionButton';

export const AboutPage = () => {
  return (
    <div className='home-container'>
      <header className='header-container'>
        <Header action='/download' />
        <div className='hero-container'>
          <div className='intro'>
            <h1>
              <span>
                We work to make luxury rides{' '}
                <span style={{ color: '#b49714' }}>easy</span>
              </span>
            </h1>
            <h3>What we are about!!!</h3>
            <div className='store-buttons'>
              <CallToActionButton store={true} />
            </div>
          </div>
          <div className='svg-content'>
            <img src={about} width={550} height={438} alt='app screenshot' />
          </div>
        </div>
      </header>
      <main className='home-main privacy'>
        <h2>About LionTaxi</h2>
        <p>
          LionTaxi is a friendly indigenous app built to make the life of
          students and indigenes in Edo state easier in terms of rural
          transportation. LionTaxi is for you and your convenience, safety, and
          security. These are what you can do with LionTaxi:
        </p>
        <ul>
          <li>
            <p>
              Map to navigate around Edo State and beyond: The primary location
              of the map is Edo State but can as well go beyond. So primarily
              you can navigate around to your location with just a click, as
              well as navigate to your destination easily.
            </p>
          </li>
          <li>
            <p>
              Places in Edo State: With this app, you can get familiar with
              major places in Edo State, like restaurants, hotels, school
              hostels, school halls, market(s), school offices. Be rest assured
              that you are not alone as a fresher in the prestigious Ambrose
              Alli University or Auchi Polytechnic
            </p>
          </li>
          <li>
            <p>
              Book Rides: As the primary purpose of this app, you can book rides
              to any destination around and beyond Edo State. Booking has never
              been this simple. With a single click, you can have a ride booked.
            </p>
          </li>
          <li>
            <p>
              Booking History: With this app, you can view pending bookings or
              completed bookings with a time of trip and amount/min.
            </p>
          </li>
          <li>
            <p>
              Familiarity with Drivers: Our drivers are certified members/staff
              of this company and to not get into the wrong car, you can confirm
              that driver exists or not within your app.
            </p>
          </li>
        </ul>
      </main>
      <Footer />
    </div>
  );
};
